import * as React from 'react';
import { styles } from './styles';
import {
  DesignShowcaseExhibitSpecification_websiteLayout,
  DesignShowcaseExhibitSpecification_style
} from '@graphql/designShowcaseTypes';
import { Columns } from '@joykit';
import { BaseButton } from '@routes/event/create/components/BaseButton';
import { Icon } from '@withjoy/joykit';

interface Props {
  exhibitId: string;
  aspectRatio: number;
  layout: DesignShowcaseExhibitSpecification_websiteLayout['template'];
  style: DesignShowcaseExhibitSpecification_style['name'];
  thumbnailUrl: string | null;
  onStartHereClick: React.MouseEventHandler<HTMLElement>;
  onPreviewThisClick: React.MouseEventHandler<HTMLElement>;
  showDesktopButtons: boolean;
}

const monitorShell = (
  <div className={styles.monitorShell}>
    <div className={styles.monitorCircle} />
    <div className={styles.monitorCircle} />
    <div className={styles.monitorCircle} />
  </div>
);

export class DesignExhibitItem extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { showDesktopButtons } = this.props;
    return (
      <Columns.Column key={this.props.exhibitId} className={styles.column} mobile={12} desktop={4} widescreen={3}>
        <div className={styles.exhibitContainer}>
          <div className={styles.exhibitPhotoContainer}>
            <div
              className={styles.exhibitPhoto(this.props.aspectRatio)}
              style={{ backgroundImage: this.props.thumbnailUrl ? `url(${this.props.thumbnailUrl})` : undefined }}
            >
              {monitorShell}
              <div className={showDesktopButtons ? `${styles.exhibitOverlay} exhibit-overlay` : undefined}>
                {showDesktopButtons && (
                  <>
                    <BaseButton
                      className={styles.darkButton}
                      value={this.props.exhibitId}
                      onClick={this.props.onPreviewThisClick}
                    >
                      Preview design
                    </BaseButton>
                    <BaseButton
                      className={showDesktopButtons ? styles.underlineButton : styles.darkButton}
                      value={this.props.exhibitId}
                      onClick={this.props.onStartHereClick}
                    >
                      Create website
                    </BaseButton>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className={showDesktopButtons ? styles.exhibitInfoContainer : styles.mobileInfoContainer}>
            <div className={styles.exhibitInfoStyle}>{this.props.style}</div>
            <div className={styles.exhibitInfoLayout}>{this.props.layout}</div>
            {!showDesktopButtons && (
              <BaseButton
                className={styles.mobileCreateButton}
                value={this.props.exhibitId}
                onClick={this.props.onStartHereClick}
              >
                {`Start with ${this.props.style}`}
                <Icon source="chevronRight" />
              </BaseButton>
            )}
          </div>
        </div>
      </Columns.Column>
    );
  }
}
